import { styled } from '@mui/material/styles';

export const FlexMatchSettingsDialogStyles = styled('div')(({ theme }) => ({
  minWidth: '320px',
  paddingTop: theme.spacing(6),

  '& table': {
    borderSpacing: theme.spacing(2),
    margin: theme.spacing(-2),

    '& th:first-child, & td:first-child': {
      paddingRight: theme.spacing(2.5),
      width: '150px',
      lineHeight: '16px',
      position: 'relative'
    },

    '& .warning-icon': {
      position: 'absolute',
      top: '50%',
      left: theme.spacing(-2),
      transform: 'translate(-100%, -50%)',
      fontSize: theme.typography.htmlFontSize
    }
  },

  '&.has-agencies': {
    paddingTop: 0,
    paddingBottom: theme.spacing(20),

    '& table': {
      margin: 0,
      padding: theme.spacing(0, 2, 0, 3.75)
    },

    '& .preference-planunit-settings, & .all-planunit-settings': {
      marginBottom: theme.spacing(7.5)
    }
  },

  '& .preference-planunit-settings': {
    marginBottom: theme.spacing(7.5)
  },

  '& .external-settings': {
    '& .table-wrapper': {
      maxHeight: '248px'
    }
  },

  '& .chip': {
    padding: theme.spacing(0, 2),

    '&.selected': {
      color: theme.palette.common.white
    },

    '& .MuiChip-label': {
      padding: 0
    },

    '& + .chip': {
      marginLeft: theme.spacing(2)
    }
  },

  '& .email-field': {
    marginTop: theme.spacing(5)
  },

  '& .info-cell': {
    position: 'relative',
    width: '10px',

    '& .info-icon': {
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      left: 0,
      fontSize: theme.typography.htmlFontSize
    }
  }
}));
